import { render, staticRenderFns } from "./recordListModules.vue?vue&type=template&id=288f63a3&scoped=true&"
import script from "./recordListModules.vue?vue&type=script&lang=js&"
export * from "./recordListModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288f63a3",
  null
  
)

export default component.exports